import Vue from 'vue'
import Vuex from 'vuex'

import _that from '@/main'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 是否在微信里
        inWechat: navigator.userAgent.toLowerCase().match(/MicroMessenger/i)=="micromessenger",

        //产品类型列表
        productList: [],

        //首页广告
        bannerList: [],

        
        hasLogin: null,

        //权益数据
        rightsData: null,

    },
    mutations: {
        //
        setState(state, data) {
            for (var i in data) {
                state[i] = data[i]
            }
        },
    },
    actions: {
        makeEv({ commit, state }){
            if( window.localStorage.getItem('not-prompt-make-guide') ){
                window.open('https://diy.mimoprint.com')
                return
            }
            // 打开提示引导
            _that.$makeguide()
        },
    },
    modules: {

    }
})
